"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PacketBrokerAgent = /*#__PURE__*/function () {
  function PacketBrokerAgent(service) {
    (0, _classCallCheck2["default"])(this, PacketBrokerAgent);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(PacketBrokerAgent, [{
    key: "_emitDefault",
    value: function _emitDefault(idObject) {
      if (!('net_id' in idObject)) {
        return _objectSpread(_objectSpread({}, idObject), {}, {
          net_id: 0
        });
      }

      return idObject;
    }
  }, {
    key: "_emitDefaults",
    value: function _emitDefaults(iterable) {
      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var probe = _step.value;

          if ('id' in probe) {
            probe.id = this._emitDefault(probe.id);
          } else {
            if ('forwarder_id' in probe) {
              probe.forwarder_id = this._emitDefault(probe.forwarder_id);
            }

            if ('home_network_id' in probe) {
              probe.home_network_id = this._emitDefault(probe.home_network_id);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return iterable;
    }
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GetInfo();

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(registration) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.Register(undefined, registration);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function register(_x) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "deregister",
    value: function () {
      var _deregister = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.Deregister();

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deregister() {
        return _deregister.apply(this, arguments);
      }

      return deregister;
    }()
  }, {
    key: "getHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _getHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.GetHomeNetworkDefaultRoutingPolicy();

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getHomeNetworkDefaultRoutingPolicy() {
        return _getHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return getHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "setHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _setHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(policy) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.SetHomeNetworkDefaultRoutingPolicy(undefined, policy);

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setHomeNetworkDefaultRoutingPolicy(_x2) {
        return _setHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return setHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "deleteHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _deleteHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.DeleteHomeNetworkDefaultRoutingPolicy();

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteHomeNetworkDefaultRoutingPolicy() {
        return _deleteHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return deleteHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "getHomeNetworkRoutingPolicy",
    value: function () {
      var _getHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(netId, tenantId) {
        var result;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GetHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    net_id: netId
                  }, tenantId ? {
                    tenant_id: tenantId
                  } : {})
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", this._emitDefault(_marshaler["default"].payloadSingleResponse(result)));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getHomeNetworkRoutingPolicy(_x3, _x4) {
        return _getHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return getHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "setHomeNetworkRoutingPolicy",
    value: function () {
      var _setHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(netId, tenantId, policy) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.SetHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    'home_network_id.net_id': netId
                  }, tenantId ? {
                    'home_network_id.tenant_id': tenantId
                  } : {})
                }, policy);

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setHomeNetworkRoutingPolicy(_x5, _x6, _x7) {
        return _setHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return setHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "deleteHomeNetworkRoutingPolicy",
    value: function () {
      var _deleteHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(netId, tenantId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.DeleteHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    net_id: netId
                  }, tenantId ? {
                    tenant_id: tenantId
                  } : {})
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deleteHomeNetworkRoutingPolicy(_x8, _x9) {
        return _deleteHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return deleteHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "listHomeNetworkRoutingPolicies",
    value: function () {
      var _listHomeNetworkRoutingPolicies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.ListHomeNetworkRoutingPolicies(undefined, params);

              case 2:
                result = _context10.sent;
                response = _marshaler["default"].unwrapPacketBrokerPolicies(result);
                response.policies = this._emitDefaults(response.policies);
                return _context10.abrupt("return", response);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function listHomeNetworkRoutingPolicies(_x10) {
        return _listHomeNetworkRoutingPolicies.apply(this, arguments);
      }

      return listHomeNetworkRoutingPolicies;
    }()
  }, {
    key: "listNetworks",
    value: function () {
      var _listNetworks = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._api.ListNetworks(undefined, params);

              case 2:
                result = _context11.sent;
                response = _marshaler["default"].unwrapPacketBrokerNetworks(result);
                response.networks = this._emitDefaults(response.networks);
                return _context11.abrupt("return", response);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function listNetworks(_x11) {
        return _listNetworks.apply(this, arguments);
      }

      return listNetworks;
    }()
  }, {
    key: "listForwarderRoutingPolicies",
    value: function () {
      var _listForwarderRoutingPolicies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._api.ListForwarderRoutingPolicies(undefined, params);

              case 2:
                result = _context12.sent;
                response = _marshaler["default"].unwrapPacketBrokerPolicies(result);
                response.policies = this._emitDefaults(response.policies);
                return _context12.abrupt("return", response);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listForwarderRoutingPolicies(_x12) {
        return _listForwarderRoutingPolicies.apply(this, arguments);
      }

      return listForwarderRoutingPolicies;
    }()
  }, {
    key: "getHomeNetworkDefaultGatewayVisibility",
    value: function () {
      var _getHomeNetworkDefaultGatewayVisibility = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        var result;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this._api.GetHomeNetworkDefaultGatewayVisibility();

              case 2:
                result = _context13.sent;
                return _context13.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getHomeNetworkDefaultGatewayVisibility() {
        return _getHomeNetworkDefaultGatewayVisibility.apply(this, arguments);
      }

      return getHomeNetworkDefaultGatewayVisibility;
    }()
  }, {
    key: "setHomeNetworkDefaultGatewayVisibility",
    value: function () {
      var _setHomeNetworkDefaultGatewayVisibility = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(gatewayVisibility) {
        var result;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this._api.SetHomeNetworkDefaultGatewayVisibility(undefined, gatewayVisibility);

              case 2:
                result = _context14.sent;
                return _context14.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setHomeNetworkDefaultGatewayVisibility(_x13) {
        return _setHomeNetworkDefaultGatewayVisibility.apply(this, arguments);
      }

      return setHomeNetworkDefaultGatewayVisibility;
    }()
  }, {
    key: "deleteHomeNetworkDefaultGatewayVisibility",
    value: function () {
      var _deleteHomeNetworkDefaultGatewayVisibility = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
        var result;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._api.DeleteHomeNetworkDefaultGatewayVisibility();

              case 2:
                result = _context15.sent;
                return _context15.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function deleteHomeNetworkDefaultGatewayVisibility() {
        return _deleteHomeNetworkDefaultGatewayVisibility.apply(this, arguments);
      }

      return deleteHomeNetworkDefaultGatewayVisibility;
    }()
  }]);
  return PacketBrokerAgent;
}();

var _default = PacketBrokerAgent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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